"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PacketBrokerAgent = /*#__PURE__*/function () {
  function PacketBrokerAgent(service) {
    (0, _classCallCheck2["default"])(this, PacketBrokerAgent);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(PacketBrokerAgent, [{
    key: "_emitDefault",
    value: function _emitDefault(idObject) {
      if (!('net_id' in idObject)) {
        return _objectSpread(_objectSpread({}, idObject), {}, {
          net_id: 0
        });
      }

      return idObject;
    }
  }, {
    key: "_emitDefaults",
    value: function _emitDefaults(iterable) {
      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var probe = _step.value;

          if ('id' in probe) {
            probe.id = this._emitDefault(probe.id);
          } else {
            if ('forwarder_id' in probe) {
              probe.forwarder_id = this._emitDefault(probe.forwarder_id);
            }

            if ('home_network_id' in probe) {
              probe.home_network_id = this._emitDefault(probe.home_network_id);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return iterable;
    }
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GetInfo();

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(registration) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.Register(undefined, registration);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function register(_x) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "deregister",
    value: function () {
      var _deregister = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.Deregister();

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deregister() {
        return _deregister.apply(this, arguments);
      }

      return deregister;
    }()
  }, {
    key: "getHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _getHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.GetHomeNetworkDefaultRoutingPolicy();

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getHomeNetworkDefaultRoutingPolicy() {
        return _getHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return getHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "setHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _setHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(policy) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.SetHomeNetworkDefaultRoutingPolicy(undefined, policy);

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setHomeNetworkDefaultRoutingPolicy(_x2) {
        return _setHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return setHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "deleteHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _deleteHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.DeleteHomeNetworkDefaultRoutingPolicy();

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteHomeNetworkDefaultRoutingPolicy() {
        return _deleteHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return deleteHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "getHomeNetworkRoutingPolicy",
    value: function () {
      var _getHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(netId, tenantId) {
        var result;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GetHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    net_id: netId
                  }, tenantId ? {
                    tenant_id: tenantId
                  } : {})
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", this._emitDefault(_marshaler["default"].payloadSingleResponse(result)));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getHomeNetworkRoutingPolicy(_x3, _x4) {
        return _getHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return getHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "setHomeNetworkRoutingPolicy",
    value: function () {
      var _setHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(netId, tenantId, policy) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.SetHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    'home_network_id.net_id': netId
                  }, tenantId ? {
                    'home_network_id.tenant_id': tenantId
                  } : {})
                }, policy);

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setHomeNetworkRoutingPolicy(_x5, _x6, _x7) {
        return _setHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return setHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "deleteHomeNetworkRoutingPolicy",
    value: function () {
      var _deleteHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(netId, tenantId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.DeleteHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    net_id: netId
                  }, tenantId ? {
                    tenant_id: tenantId
                  } : {})
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deleteHomeNetworkRoutingPolicy(_x8, _x9) {
        return _deleteHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return deleteHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "listHomeNetworkRoutingPolicies",
    value: function () {
      var _listHomeNetworkRoutingPolicies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.ListHomeNetworkRoutingPolicies(undefined, params);

              case 2:
                result = _context10.sent;
                response = _marshaler["default"].unwrapPacketBrokerPolicies(result);
                response.policies = this._emitDefaults(response.policies);
                return _context10.abrupt("return", response);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function listHomeNetworkRoutingPolicies(_x10) {
        return _listHomeNetworkRoutingPolicies.apply(this, arguments);
      }

      return listHomeNetworkRoutingPolicies;
    }()
  }, {
    key: "listNetworks",
    value: function () {
      var _listNetworks = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._api.ListNetworks(undefined, params);

              case 2:
                result = _context11.sent;
                response = _marshaler["default"].unwrapPacketBrokerNetworks(result);
                response.networks = this._emitDefaults(response.networks);
                return _context11.abrupt("return", response);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function listNetworks(_x11) {
        return _listNetworks.apply(this, arguments);
      }

      return listNetworks;
    }()
  }, {
    key: "listForwarderRoutingPolicies",
    value: function () {
      var _listForwarderRoutingPolicies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._api.ListForwarderRoutingPolicies(undefined, params);

              case 2:
                result = _context12.sent;
                response = _marshaler["default"].unwrapPacketBrokerPolicies(result);
                response.policies = this._emitDefaults(response.policies);
                return _context12.abrupt("return", response);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listForwarderRoutingPolicies(_x12) {
        return _listForwarderRoutingPolicies.apply(this, arguments);
      }

      return listForwarderRoutingPolicies;
    }()
  }, {
    key: "getHomeNetworkDefaultGatewayVisibility",
    value: function () {
      var _getHomeNetworkDefaultGatewayVisibility = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        var result;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this._api.GetHomeNetworkDefaultGatewayVisibility();

              case 2:
                result = _context13.sent;
                return _context13.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getHomeNetworkDefaultGatewayVisibility() {
        return _getHomeNetworkDefaultGatewayVisibility.apply(this, arguments);
      }

      return getHomeNetworkDefaultGatewayVisibility;
    }()
  }, {
    key: "setHomeNetworkDefaultGatewayVisibility",
    value: function () {
      var _setHomeNetworkDefaultGatewayVisibility = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(gatewayVisibility) {
        var result;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this._api.SetHomeNetworkDefaultGatewayVisibility(undefined, gatewayVisibility);

              case 2:
                result = _context14.sent;
                return _context14.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setHomeNetworkDefaultGatewayVisibility(_x13) {
        return _setHomeNetworkDefaultGatewayVisibility.apply(this, arguments);
      }

      return setHomeNetworkDefaultGatewayVisibility;
    }()
  }, {
    key: "deleteHomeNetworkDefaultGatewayVisibility",
    value: function () {
      var _deleteHomeNetworkDefaultGatewayVisibility = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
        var result;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._api.DeleteHomeNetworkDefaultGatewayVisibility();

              case 2:
                result = _context15.sent;
                return _context15.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function deleteHomeNetworkDefaultGatewayVisibility() {
        return _deleteHomeNetworkDefaultGatewayVisibility.apply(this, arguments);
      }

      return deleteHomeNetworkDefaultGatewayVisibility;
    }()
  }]);
  return PacketBrokerAgent;
}();

var _default = PacketBrokerAgent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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